export function trigger() {
  const triggerContent = document.querySelector('.trigger-about');
  if (triggerContent) {
    triggerContent.addEventListener('click', function (e) {
      if (!document.body.classList.contains('is-about-en')) {
        document.body.classList.add('is-about-en');
      } else {
        document.body.classList.remove('is-about-en');
      }
      e.preventDefault();
    });
  }

  const headerTrigger = document.querySelector('.trigger-header');
  if (headerTrigger) {
    headerTrigger.addEventListener('click', () => {
      if (!document.body.classList.contains('is-pause')) {
        document.body.classList.add('is-pause');
      } else {
        document.body.classList.remove('is-pause');
      }
    })
  }
}